var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVdiscard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(444 1673)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 32,
    height: 32,
    transform: "translate(-444 -1673)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_70d8ca09c3cd282b71f5d5bf3838f9a5",
    "data-name": "70d8ca09c3cd282b71f5d5bf3838f9a5",
    d: "M10.386,5.177A19.963,19.963,0,0,0,5.94,6.609,5.065,5.065,0,0,0,4.161,8.821C3.5,10.05,2.961,11.487,2.093,13.6a24.383,24.383,0,0,0-1.04,7.431c.029,1.244.171,2.215,1.446,2.951a28.4,28.4,0,0,0,3.585,1.966c1.186.463,2,.8,2.545.333a4.132,4.132,0,0,0,.912-1.273s.521-.723-.463-1.156S7.6,23.114,7.646,22.666s.115-.694.361-.636a6.145,6.145,0,0,0,3.052,1.576,20.544,20.544,0,0,0,4.4.405,20.483,20.483,0,0,0,4.4-.405,6.139,6.139,0,0,0,3.051-1.576c.246-.058.317.188.361.635s-.448.753-1.431,1.187-.463,1.156-.463,1.156a4.143,4.143,0,0,0,.912,1.273c.549.463,1.359.13,2.544-.333a28.289,28.289,0,0,0,3.586-1.966c1.274-.736,1.417-1.707,1.446-2.951A24.363,24.363,0,0,0,28.82,13.6c-.867-2.113-1.4-3.55-2.068-4.779a5.075,5.075,0,0,0-1.778-2.213,20.019,20.019,0,0,0-4.447-1.431,1.313,1.313,0,0,0-1.264.68l-.34.752a26.125,26.125,0,0,0-3.45-.435,26.664,26.664,0,0,0-3.48.435l-.34-.753a1.314,1.314,0,0,0-1.265-.679Zm.106,9.023h.036A2.684,2.684,0,0,1,13.1,16.981a2.684,2.684,0,0,1-2.576,2.781,2.684,2.684,0,0,1-2.576-2.781A2.687,2.687,0,0,1,10.492,14.2Zm9.893,0h.036a2.688,2.688,0,0,1,2.54,2.781,2.684,2.684,0,0,1-2.576,2.781,2.683,2.683,0,0,1-2.576-2.781A2.684,2.684,0,0,1,20.385,14.2Z",
    transform: "translate(-443.457 -1672.84)",
    fill: "#16ebc3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdiscard);
export default __webpack_public_path__ + "static/media/vdiscard.85f24c95a2b6b1512100b948b0d3e5b0.svg";
export { ForwardRef as ReactComponent };